import { render, staticRenderFns } from "./UserRemarkN.vue?vue&type=template&id=04b11f62&scoped=true&"
import script from "./UserRemarkN.vue?vue&type=script&lang=js&"
export * from "./UserRemarkN.vue?vue&type=script&lang=js&"
import style0 from "./UserRemarkN.vue?vue&type=style&index=0&id=04b11f62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b11f62",
  null
  
)

export default component.exports